import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function impersonateUser(userId) {
	let response = await getAPIResponse(`/v1/user/${userId}/impersonate`, {}, "POST");
	return response;
}
